module.exports = __webpack_public_path__ + "static/wasm/greycat.d46f8a1d.wasm";